module.exports = __webpack_public_path__ + "img/SNS.6d7cfa17.png";